import React, { useEffect, useState } from 'react';
import styles from './CrmToken.module.scss';
import { useNavigate } from 'react-router-dom';
import { Flex, Input } from 'antd';
import CustomButton from '../../../components/UI/CustomButton/CustomButton';
import { ReactComponent as LoaderIcon } from '../../../assets/images/global-icons/loader.svg';
import { ReactComponent as OkIcon } from '../../../assets/images/global-icons/ok.svg';
import {CrmItem, useSendCrmTokenMutation} from "../../../redux/API/CrmSlice"
import { useGetMeQuery } from '../../../redux/API/userSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useLocation } from 'react-router-dom';

interface UserDataInterface {
  accountType: string;
  authType: string;
  avatarKey: string;
  company: any;
  createdAt: string;
  email: string;
  firstName: string;
  id: string;
  isBlocked: boolean;
  isDeleted: boolean;
  lastName: string;
  phone: string;
  updatedAt: string;
}

export const CrmToken = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [sendCrmToken] = useSendCrmTokenMutation();
  const [userData, setUserData] = useState<UserDataInterface | undefined>();
  const { isAuth } = useSelector((state: RootState) => state.isAuth);
  const { data: user } = useGetMeQuery({ accessToken: isAuth });
  const location = useLocation();
  const selectedCrm = location.state as CrmItem;
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setToken(e.target.value);
    setError(false);
  };

  useEffect(() => {
    setUserData(user?.data);
  }, [user]);

  const handleSubmit = async () => {
    if (token.trim() === '') return;

    setIsLoading(true);
    setError(false);

    try {
      const response = await sendCrmToken({ token, userId: user?.data?.id, type: selectedCrm.type }).unwrap();


      if (response.success) {
        setIsLoading(false);
        setIsSuccess(true);
      } else {
        throw new Error('Invalid token');
      }
    } catch (err) {
      setIsLoading(false);
      setError(true);
    }
  };
  
  return (
    <Flex vertical className={styles.crmToken}>

      <p className={styles.title}>
        Please enter the received token to <br />
        authorize access to the CRM system
      </p>

      <div className={styles.inputWrapper}>
        <Input
          className={`${styles.input} ${error ? styles.inputError : ''}`}
          placeholder="CRM token"
          value={token}
          onChange={handleChange}
        />
        {error && <p className={styles.errorMessage}>Please double-check your token and try again</p>}
      </div>

      <Flex className={styles.nextButtonWrapper}>
        <CustomButton text="Next" disable={token.trim() === ''} onClick={handleSubmit} />
      </Flex>
      {(isLoading || isSuccess) && (
        <div className={styles.overlay}>
          <Flex vertical className={styles.modal}>
            {isLoading && (
              <>
                <LoaderIcon className={styles.modal__loader__icon} />
                <h2 className={styles.modal__loader__modalTitle}>
                  Please wait, we are
                  <br />
                  integrating CRM
                </h2>
                <p className={styles.modal__loader__modalSubtitle}>This may take a few seconds</p>
              </>
            )}
            {isSuccess && (
              <div className={styles.overlay} onClick={() => navigate('/')}>
                <Flex
                  vertical
                  className={styles.modal}
                  onClick={(e) => e.stopPropagation()} 
                >
                  <OkIcon className={styles.modal__success__icon} />
                  <h2 className={styles.modal__success__modalTitle}>
                    CRM system
                    <br />
                    successfully integrated!
                  </h2>
                </Flex>
              </div>
            )}
          </Flex>
        </div>
      )}
    </Flex>
  );
};
